/**
 * Undo's routes (CS r5b deliverable 164; DECISIONS 212 item 4), owner 2.L, stage `s1`, since
 * `exit-2b`, frozen. `undo.batches.list` lists change batches newest first; `undo.apply` reverts
 * one batch in a new batch of origin `undo` that names it, or answers 409 `undo_refused` (`reason`
 * `row_changed` or `not_undoable`, at most 50 `rows`) with nothing written. A repeat answers the
 * first undo again. `undo.apply` is not marked `changeBatch`: an undo is never offered for Undo.
 * No route names a document: `reference` is `none`.
 */
import { IdParams } from '../dto/common.js';
import { listOf } from '../dto/list.js';
import { ChangeBatchV1, UndoBatchesQueryV1, UndoResultV1 } from '../dto/undo.js';
import { defineRoute } from '../route/define-route.js';
import { EXAMPLE_IDS } from './example-ids.js';
import { EXAMPLE_CHANGE_BATCH, EXAMPLE_UNDO_RESULT } from './examples-2b-batches.js';
const undo = {
    auth: 'session',
    status: 'frozen',
    since: 'exit-2b',
    owner: '2.L',
    stage: 's1',
};
/** The change batches, newest first: a session's, a route's or all, a page at a time. */
export const undoBatchesList = defineRoute({
    id: 'undo.batches.list',
    method: 'GET',
    path: '/api/undo/batches',
    query: UndoBatchesQueryV1,
    response: { kind: 'json', schema: listOf(ChangeBatchV1) },
    reference: 'none',
    ...undo,
    examples: {
        request: { query: { sessionId: EXAMPLE_IDS.sessionSaltInTheWells.id, limit: 20 } },
        response: { items: [EXAMPLE_CHANGE_BATCH], next: null },
    },
});
/** Revert one batch; a repeat answers the same result and writes nothing. */
export const undoApply = defineRoute({
    id: 'undo.apply',
    method: 'POST',
    path: '/api/undo/batches/:id/undo',
    params: IdParams,
    response: { kind: 'json', schema: UndoResultV1 },
    errors: { 409: ['undo_refused'] },
    reference: 'none',
    ...undo,
    examples: {
        request: { params: { id: EXAMPLE_IDS.batchSaltTimePromote.id } },
        response: EXAMPLE_UNDO_RESULT,
        consumes: true,
    },
});
//# sourceMappingURL=undo.js.map